<main class="page-wrapper" role="main">
    <article class="option-card" role="article" [attr.aria-labelledby]="'terms-title'">
        <header class="option-card-header">
            <h1 id="terms-title">
                <i class="fas fa-file-alt" aria-hidden="true"></i>
                {{ 'LEGAL.TITLE.TERMS' | translate }}
            </h1>
        </header>
        <section class="option-card-body"
                 role="region"
                 [attr.aria-label]="'ACCESSIBILITY.LEGAL_CONTENT' | translate"
                 [innerHTML]="bodyText$ | async | translate">
        </section>
    </article>
</main>
